import { ShakenStirRegistration } from 'components/ShakenStirRegistration';
import { UserDataResult, TeamResult } from "interfaces/users";

interface StirShakenModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  user: UserDataResult | null;
  team: TeamResult | null;
}

export function StirShakenModal({ 
  isOpen, 
  onClose, 
  onSuccess, 
  user, 
  team 
}: StirShakenModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <ShakenStirRegistration
          teamId={user?.team_id ?? ''}
          teamName={(team?.team === 'NO_TEAM_ASSIGNED' ? user?.user_name : team?.team) ?? user?.user_name ?? ''}
          onCancel={onClose}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  );
}